import { Button, ButtonAppearance, ButtonSize } from '@bechtel/gds';
import styled from 'styled-components';
interface ButtonProps {
  appearance?: ButtonAppearance;
}
export const IconButtonStyled = styled(Button).attrs<ButtonProps>((props) => ({
  appearance: props.appearance ? props.appearance : ButtonAppearance.TERTIARY,
  size: ButtonSize.SMALL,
}))`
  justify-content: space-evenly;
  height: 30px;
  width: 30px;
`;
